export default function getWpUrl() {
  const url = new URL(document.URL);
  const { hostname, protocol } = url;
  return process.env.REACT_APP_WP_URL
    ? process.env.REACT_APP_WP_URL
    : `${protocol}//${hostname}:3000/`;
}
